var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 1.94531L18.4609 18.1562C18.4219 18.5469 18.1875 18.8984 17.8359 19.0938C17.6406 19.1719 17.4453 19.25 17.2109 19.25C17.0547 19.25 16.8984 19.2109 16.7422 19.1328L11.9766 17.1406L9.98438 20.1094C9.82812 20.3828 9.55469 20.5 9.28125 20.5C8.85156 20.5 8.5 20.1484 8.5 19.7188V15.9688C8.5 15.6562 8.57812 15.3828 8.73438 15.1875L17.25 4.25L5.76562 14.6016L1.74219 12.9219C1.3125 12.7266 1 12.3359 1 11.8281C0.960938 11.2812 1.19531 10.8906 1.625 10.6562L19.125 0.695312C19.5156 0.460938 20.0625 0.460938 20.4531 0.734375C20.8438 1.00781 21.0391 1.47656 20.9609 1.94531Z",
    fill: "#2DC76D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.7e1635ed86170bfdcf6a798dbc531213.svg";
export { ForwardRef as ReactComponent };